import React, { useEffect } from "react";

const Terms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <article className="container">
            <div className="page mb-2">
            <h2>Terms of Service</h2>
            <h3>1. Introduction</h3>
            <p>
                Welcome to Grassroots360 LTD ("we", "our", "us"). These Terms of Service ("Terms") govern your use of our website located at 
                <a href="https://grassroots360.co.uk" target="_blank" rel="noopener noreferrer"> https://grassroots360.co.uk</a> 
                (the "Site") and any related services provided by Grassroots360 LTD.
            </p>
            <p>
                By accessing or using the Site, you agree to be bound by these Terms. If you do not agree with these Terms, you must not use the Site.
            </p>

            <h3>2. Use of the Site</h3>
            <p>
                You agree to use the Site only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's 
                use and enjoyment of the Site. Prohibited behavior includes harassing or causing distress or inconvenience to any other user, transmitting 
                obscene or offensive content, or disrupting the normal flow of dialogue within the Site.
            </p>

            <h3>3. Intellectual Property</h3>
            <p>
                All content on the Site, including text, graphics, logos, images, and software, is the property of Grassroots360 LTD or its content suppliers 
                and is protected by international copyright laws. You may not reproduce, distribute, or create derivative works from any of the content on 
                the Site without our express written permission.
            </p>

            <h3>4. User Accounts</h3>
            <p>
                To access certain features of the Site, you may need to create an account. You are responsible for maintaining the confidentiality of your 
                account information, including your password, and for all activities that occur under your account. You agree to notify us immediately of 
                any unauthorized use of your account or any other breach of security.
            </p>

            <h3>5. Termination</h3>
            <p>
                We reserve the right to terminate or suspend your access to the Site at any time, without notice, for conduct that we believe violates these 
                Terms or is harmful to other users of the Site, us, or third parties, or for any other reason.
            </p>

            <h3>6. Limitation of Liability</h3>
            <p>
                In no event shall Grassroots360 LTD, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, 
                incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other 
                intangible losses, resulting from:
            </p>
            <ul>
                <li>your use or inability to use the Site;</li>
                <li>any unauthorized access to or use of our servers and/or any personal information stored therein;</li>
                <li>any interruption or cessation of transmission to or from the Site;</li>
                <li>any bugs, viruses, trojan horses, or the like that may be transmitted to or through our Site by any third party;</li>
                <li>any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content posted, emailed, 
                    transmitted, or otherwise made available through the Site;</li>
                <li>any other matter relating to the Site.</li>
            </ul>

            <h3>7. Changes to These Terms</h3>
            <p>
                We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on the Site. You are 
                advised to review these Terms periodically for any changes. Changes to these Terms are effective when they are posted on this page.
            </p>

            <h3>8. Governing Law</h3>
            <p>
                These Terms shall be governed and construed in accordance with the laws of England, without regard to its conflict of law provisions.
            </p>

            <h3>9. Reporting Abuse</h3>
            <p>
                If you encounter any abusive behavior, offensive content, or misuse of the Site, please report it to us at
                <a href="mailto:info@grassroots360.co.uk"> info@grassroots360.co.uk</a>. Please include as much detail as possible,
                such as the nature of the abuse and where it occurred, so that we can investigate promptly. We take all reports
                seriously and will take appropriate action in accordance with these Terms.
            </p>

            <h3>10. Contact Us</h3>
            <p>
                If you have any questions about these Terms, please contact us at 
                <a href="mailto:info@grassroots360.co.uk"> info@grassroots360.co.uk</a>.
            </p>
            </div>
        </article>
    )
}

export default Terms;